<!-- src/components/Sources.vue -->
<template>
  <div class="source-outer" v-if="Array.isArray(sources) && sources.length > 0">
    <div class="source-header">
      <h4>Sources:</h4>
      <div class="source-container">
        <button v-if="showLeftArrow" class="arrow left" @click="scrollLeft">‹</button>
        <div class="source-list-wrapper">
          <div class="source-list" ref="sourceList">
            <div class="source" v-for="(source, index) in sources" :key="index">
              {{ index + 1 }}
              <button class="button-source" @click="openSource(source.url)">
                <span>{{ source.title }}</span>
              </button>
            </div>
          </div>
        </div>
        <button v-if="showRightArrow" class="arrow right" @click="scrollRight">›</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, onMounted, watch } from 'vue';

export default defineComponent({
  name: 'Sources',
  props: {
    sources: {
      type: Array as PropType<Array<{ title: string, url: string }>>,
      required: false
    }
  },
  methods: {
    openSource(url: string) {
      window.open(url, '_blank');
    }
  },
  setup(props) {
    const sourceList = ref<HTMLElement | null>(null);
    const showLeftArrow = ref(false);
    const showRightArrow = ref(false);

    const updateArrowsVisibility = () => {
      if (sourceList.value) {
        const { scrollLeft, scrollWidth, clientWidth } = sourceList.value;
        showLeftArrow.value = scrollLeft > 0;
        showRightArrow.value = scrollLeft + clientWidth < scrollWidth;
      }
    };

    const scrollLeft = () => {
      if (sourceList.value) {
        sourceList.value.scrollBy({ left: -200, behavior: 'smooth' });
      }
    };

    const scrollRight = () => {
      if (sourceList.value) {
        sourceList.value.scrollBy({ left: 200, behavior: 'smooth' });
      }
    };

    onMounted(() => {
      updateArrowsVisibility();
      if (sourceList.value) {
        sourceList.value.addEventListener('scroll', updateArrowsVisibility);
      }
    });

    watch(() => props.sources, () => {
      updateArrowsVisibility();
    });

    return {
      sourceList,
      showLeftArrow,
      showRightArrow,
      scrollLeft,
      scrollRight
    };
  }
});
</script>

<style scoped>
.source-outer {
  margin-top: 0px;
}

.source-header {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  line-height: 1rem;
}

.source-container {
  display: flex;
  align-items: center;
  position: relative;
  flex-grow: 1;
  overflow: hidden;
}

.source-list-wrapper {
  flex-grow: 1;
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
}

.source-list {
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  margin-left: 26px;
  margin-right: 26px;
  white-space: nowrap;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  /* hide scrollbar IE and Edge */
  scrollbar-width: none;
  /* hide scrollbar Firefox */
}

/* Hide scrollbar for Chrome, Safari, and Opera */
.source-list::-webkit-scrollbar {
  display: none;
}

.source {
  display: inline-block;
  margin-right: 10px;
}

.button-source {
  border: 2px solid red;
  background-color: white;
  font-weight: bold;
  padding: 2px;
  cursor: pointer;
}

.arrow {
  background: none;
  border: none;
  font-size: 2.5em;
  margin-top: -7px;
  cursor: pointer;
  transition: transform 0.3s, font-weight 0.3s;
  position: relative;
  z-index: 1;
}

.arrow:hover {
  transform: scale(1.2);
  font-weight: bold;
}

.arrow.left {
  margin-right: -26px;
}

.arrow.right {
  margin-left: -26px;
}
</style>
